import { useState, useRef } from "react";
import { createPortal } from "react-dom";
import { cn } from "@utils";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

export const ReasonPopover = ({ field, options, isSubmitted }) => {
  const [open, setOpen] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const buttonRef = useRef(null);
  const selected = options.find(r => r.value === field.value);
  const showError = !field.value && isSubmitted;

  const handleToggle = () => {
    if (!open && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setCoords({ top: rect.bottom + 6, left: rect.left });
    }
    setOpen(v => !v);
  };

  return (
    <div className="inline-block">
      <button
        ref={buttonRef}
        type="button"
        onClick={handleToggle}
        className={cn(
          "inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1.5 rounded-full border transition-all",
          selected
            ? "bg-primary-50 border-primary-300 text-primary-700"
            : showError
              ? "bg-red-50 border-red-300 text-red-500"
              : "bg-white border-zinc-200 text-zinc-400 hover:border-zinc-300 hover:text-zinc-600"
        )}
      >
        {selected?.label ?? "Select reason"}
        <ChevronDownIcon className={cn("size-3 shrink-0 transition-transform duration-150", open && "rotate-180")} />
      </button>

      {open && createPortal(
        <>
          <div className="fixed inset-0 z-[100]" onMouseDown={() => setOpen(false)} />
          <div
            className="fixed z-[101] w-124 bg-white rounded-xl border border-zinc-200 shadow-xl p-2"
            style={{ top: coords.top, left: coords.left }}
          >
            <div className="flex flex-wrap gap-1.5">
              {options.map(({ value, label }) => {
                const isSelected = field.value === value;
                return (
                  <button
                    key={value}
                    type="button"
                    onMouseDown={() => { field.onChange(value); setOpen(false); }}
                    className={cn(
                      "whitespace-nowrap text-xs font-medium px-2.5 py-1.5 rounded-full border transition-all",
                      isSelected
                        ? "bg-primary-50 border-primary-300 text-primary-700"
                        : "bg-white border-zinc-200 text-zinc-600 hover:border-zinc-300 hover:bg-zinc-50"
                    )}
                  >
                    {label}
                  </button>
                );
              })}
            </div>
          </div>
        </>,
        document.body
      )}
    </div>
  );
};
